import React,{useState} from 'react'
import KioskHeader from '../../sections/KioskHeader'
import { useAlert } from '../../../../context/AlertContext'
import { Step, StepLabel, Stepper, StepContent } from '@mui/material';

import CustomerFormComponent from '../components/CustomerFormComponent';
import KioskNav from '../../sections/KioskNav';
import { ArrowBack } from '@mui/icons-material';

import ScheduleQueueSelectComponent from '../components/ScheduleQueueSelectComponent';
import ScheduleServiceSelectComponent from '../components/ScheduleServiceSelectComponent';
import ScheduleCustomerFormComponent from '../components/ScheduleCustomerFormComponent';

function KioskScheduleCheckinPage() {

    const {AppAlert}  = useAlert()
    const [activeStep,setActiveStep] = useState(0);
    const [selectedQueue,setSelectedQueue] = useState(null);
    const [selectedDate,setSelectedDate] = useState(null);
    const [selectedService,setSelectedService] = useState(null);

    return (
        <div className='container'>
            <KioskHeader/>
            <div className='row'>
                <div className='col-md-12'>
                    <Stepper activeStep={activeStep} orientation='vertical'>
                        <Step>
                            <StepLabel onClick={()=>{setActiveStep(0)}}>{selectedQueue? selectedQueue.title : "Select Queue"}</StepLabel>
                            <StepContent>
                                <ScheduleQueueSelectComponent
                                    selectedQueue={selectedQueue} 
                                    setSelectedQueue={setSelectedQueue} 
                                    setActiveStep={setActiveStep} 
                                />
                            </StepContent>
                        </Step>

                        <Step>
                            <StepLabel>{selectedService? selectedService.title : "Select Date and Service"}</StepLabel>
                            <StepContent>
                                {selectedQueue &&
                                    <ScheduleServiceSelectComponent
                                        selectedQueue={selectedQueue} 
                                        selectedService={selectedService} 
                                        selectedDate={selectedDate}
                                        setSelectedService={setSelectedService}
                                        setActiveStep={setActiveStep}
                                        setSelectedDate={setSelectedDate}
                                    />
                                }
                                <button className='btn btn-lg btn-outline-primary mt-2'
                                    onClick={()=>{
                                        setActiveStep(0);
                                    }}
                                >
                                    <ArrowBack/> Back 
                                </button>
                            </StepContent>
                        </Step>
                        <Step>
                            <StepLabel>Visitor Details</StepLabel>
                            <StepContent>
                                {selectedQueue && activeStep===2 && 
                                    <ScheduleCustomerFormComponent 
                                        queueId={selectedQueue.id} 
                                        serviceId={selectedService.id}
                                        selectedDate={selectedDate} 
                                    />
                                }
                                <button className='btn btn-lg btn-outline-primary mt-2'
                                    onClick={()=>{
                                        setActiveStep(1);
                                    }}
                                >
                                    <ArrowBack/> Back 
                                </button>
                            </StepContent>
                        </Step>
                    </Stepper>
                </div>
            </div>
            <KioskNav/>                
        </div>
        
    )
}

export default KioskScheduleCheckinPage